import { Layout } from 'antd';
import Loading from 'components/Loading';
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const Content = () => {
  return (
    <Layout.Content className="p-2">
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </Layout.Content>
  );
};

export default Content;
